<script setup lang="ts">
interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

</script>

<template>
  <div :class="`table-cell ${props.cellConfig.class || ''}`">
    <span class="value">{{props.data || '-'}}</span>
  </div>
</template>

<style scoped>

</style>
